import React, { FC, useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useHistory } from 'react-router-dom';
import { ConsentFormPage } from 'src/modules/auth/screens/ConsentFormPage';
import { ClickwrapConsentForm } from 'src/modules/auth/screens/ClickwrapConsentForm';
import { RouteComponentProps } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'src/config/rootStore';
import { getUserInformation } from 'src/modules/user/selectors/userSelectors';

interface ConsentFormContainerProps
    extends RouteComponentProps<
        {},
        {},
        {
            token: string;
            companyCode: string;
            companyName: string;
            firstName: string;
            lastName: string;
            email: string;
            country: string;
            acceptedContractVersions: string[];
            birthDate: string;
            uidb64: string;
            languagePreference: string;
            isSSOFlow: boolean;
        }
    > {}

export const ConsentFormContainer: FC<ConsentFormContainerProps> = props => {
    const flags = useFlags();
    const dispatch = useDispatch<Dispatch>();
    const { uuid } = useSelector(getUserInformation);
    const companyName = props.location.state?.companyName;
    const isSSOFlow = props.location.state?.isSSOFlow;
    const history = useHistory();

    useEffect(() => {
        if (isSSOFlow) {
            if (!uuid) {
                history.push('/registration');
            }
        } else {
            if (companyName) {
                dispatch.user.saveUserInfo({
                    uuid: uuid || `registered-user-${new Date().getTime()}`,
                    company: companyName,
                });
                return;
            } else {
                // This is most likely can't happen, cause company code is required during registration, but it's better to be safe anyway.
                history.push('/register');
            }
        }
    }, [companyName, dispatch.user, history, isSSOFlow, uuid]);

    if (flags.fdrEnableClickwrapConsentsWebRelease) {
        return <ClickwrapConsentForm {...props.location.state} />;
    }

    return <ConsentFormPage {...props} />;
};
